module.exports = __webpack_public_path__ + "static/media/team-dan-old.e571d725.jpg";